module.exports = __webpack_public_path__ + "static/Gallery-2-9cb7d4bd4818f4fe7f5c1aff043bf088.jpg";